/**
 * Display names for the BETA suite tools (cyber, D&O, home, personal lines, RT,
 * premium development, loss runs, real estate, commercial lines, coverage &
 * claims analysis, notice trigger registers). Mirrors TOOL_INFO names in
 * WorkflowTools.tsx so reports, jobs and notifications match the tool picker.
 */
export const BETA_TOOL_LABELS: Record<string, string> = {
  cyber_auto: 'Cyber',
  cyber_benchmark: 'Cyber Policy Benchmark',
  cyber_renewal_delta: 'Cyber Renewal Delta (YOY)',
  cyber_war_systemic: 'Cyber War & Systemic Exclusion Analyzer',
  cyber_ransomware_trap: 'Cyber Ransomware Trap Scanner',
  cyber_quote_comparison: 'Cyber Quote Comparison',
  do_auto: 'D&O',
  do_benchmark: 'D&O Benchmark',
  do_renewal_delta: 'D&O Renewal Delta (YOY)',
  do_distress_scanner: 'D&O Financial Distress Scanner',
  do_emerging_exposure: 'D&O Emerging-Exposure Analyzer',
  home_auto: 'Home Insurance',
  home_owner_benchmark: 'HO Owner Benchmark',
  home_tenant_condo_benchmark: 'HO Tenant + Condo Benchmark',
  home_quote_comparison: 'HO Quote Comparison',
  home_renewal_delta: 'HO Renewal Delta (YOY)',
  home_dp_rental_benchmark: 'Dwelling Fire / Rental Benchmark',
  home_dp_rental_renewal_delta: 'Dwelling Fire / Rental Renewal Delta (YOY)',
  home_hnw_benchmark: 'HNW Homeowners Benchmark',
  plines_auto: 'Personal Lines',
  pa_benchmark: 'Personal Auto Benchmark',
  pa_quote_comparison: 'Personal Auto Quote Comparison',
  pa_renewal_delta: 'Personal Auto Renewal Delta (YOY)',
  umb_benchmark: 'Personal Umbrella Benchmark',
  umb_quote_comparison: 'Personal Umbrella Quote Comparison',
  umb_renewal_delta: 'Personal Umbrella Renewal Delta (YOY)',
  rt_auto: 'Requirements Consulting',
  rt_requirements_reviewer: 'Insurance Requirements Reviewer (RT-1R)',
  rt_conformance_alignment: 'Requirements Compliance Alignment (RT-3)',
  premdev_auto: 'Premium Development',
  premdev_workers_comp: 'Premium Dev — Workers Comp',
  premdev_prof_liability: 'Premium Dev — Professional Liab + D&O',
  premdev_general_liability: 'Premium Dev — General Liability',
  premdev_property: 'Premium Dev — Property',
  premdev_package_bop: 'Premium Dev — Package / BOP',
  lossrun_auto: 'Loss Runs',
  lossrun_fact_engine: 'Loss History Fact Engine (CLM-1)',
  lossrun_mitigation_wc: 'Loss Mitigation / UW Presentation — WC',
  re_auto: 'Real Estate',
  re_policy_extraction: 'RE Portfolio Coverage Extractor',
  re_risk_transfer: 'RE Contract Risk Transfer Analyzer',
  re_br_financials: "Builder's Risk Financials Extractor",
  re_zone_extractor: 'Procurement Zone-Value Extractor',
  re_portfolio_brief: 'RE Portfolio Board Brief',
  rt_compliance_verifier: 'Compliance Verifier (RT-2)',
  cl_auto: 'Commercial Lines (P&C)',
  cl_gl_benchmark: 'GL Benchmark (CL-GL)',
  cl_property_benchmark: 'Commercial Property Benchmark',
  cl_commercial_auto_benchmark: 'Commercial Auto Benchmark',
  cl_inland_marine_benchmark: 'Inland Marine Benchmark',
  cl_excess_benchmark: 'Excess & Umbrella Benchmark',
  cl_package_benchmark: 'Commercial Package Benchmark',
  cl_bop_benchmark: 'BOP Benchmark',
  cl_nytpao_flow: 'NY Action-Over Flow Analysis',
  cl_package_quote_comparison: 'Package Quote Comparison',
  cl_bop_quote_comparison: 'BOP Quote Comparison',
  cl_xarch_quote_comparison: 'Cross-Architecture Quote Comparison (PKG↔BOP)',
  cl_package_renewal_delta: 'Package Renewal Delta (YOY)',
  cl_bop_renewal_delta: 'BOP Renewal Delta (YOY)',
  ca_auto: 'Coverage & Claims Analysis',
  ca_coverage_determination: 'Coverage Determination (CA-1)',
  ca_portfolio_determination: 'Portfolio Coverage Determination (CA-2)',
  ca_carrier_position_audit: 'Carrier Position Audit (CA-3)',
  ntr_auto: 'Notice Trigger Registers',
  ntr_first_party: 'Notice Trigger Register — First-Party & Specialty',
  ntr_property_liability: 'Notice Trigger Register — Property & Liability',
  ntr_mgmt_professional: 'Notice Trigger Register — Management & Professional',
};

/** Readable label for any workflow type: BETA tool name, else the id title-cased. */
export const formatWorkflowLabel = (workflowType: string): string =>
  BETA_TOOL_LABELS[workflowType]
  || workflowType.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
